import {
  addBackLink,
  addHiddenTemplateRow,
  addSpacerRow,
  addTitleRow,
  applyColumnLayout,
  borderFourColHeaderRow,
  BODY_FONT,
  DATA_START_ROW,
  HEADER_FONT_12,
  HEADER_ROW,
  hideColumnsAfter,
  hideRowsThrough,
  LINK_FONT,
  RED_LABEL_FONT,
  setCell,
  setValueDataRow,
  setupSheetView,
} from "./detailSheetCommon";

const COL_START = 4;
const COL_END = 7;
const NIC_CODE_LIST_URL = "https://www.ncs.gov.in/Documents/NIC_Sector.pdf";

function formatTurnoverPct(value) {
  if (value === null || value === undefined || value === "") return "";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  return num.toFixed(4);
}

export function buildProductsServicesSoldSheet(workbook, sectionA) {
  const ws = workbook.addWorksheet("Products services sold");
  applyColumnLayout(
    ws,
    {
      A: 9.1796875,
      B: 9.1796875,
      C: 9.1796875,
      D: 8.81640625,
      E: 30.453125,
      F: 53.1796875,
      G: 33.1796875,
      H: 9.1796875,
      I: 9.1796875,
      J: 9.1796875,
    },
    ["A", "B"]
  );
  hideColumnsAfter(ws, 10);
  setupSheetView(ws, { xSplit: 3, ySplit: 11, topLeftCell: "D12", zoomScale: 80 });
  hideRowsThrough(ws, 5);

  addBackLink(ws, COL_END);
  addTitleRow(
    ws,
    COL_START,
    COL_END,
    "Products/Services sold by the entity (accounting for 90% of the entity's Turnover)"
  );

  borderFourColHeaderRow(ws, HEADER_ROW);
  ws.getRow(HEADER_ROW).height = 15.5;
  [
    { col: COL_START, label: "Sr. No." },
    { col: 5, label: "Product/Service" },
    { col: 6, label: "NIC Code" },
    { col: COL_END, label: "% of total Turnover contributed" },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, { font: HEADER_FONT_12, bordered: false });
  });

  addHiddenTemplateRow(ws, COL_START, COL_END);
  addSpacerRow(ws, COL_START, COL_END);

  const products = sectionA?.productServices?.productsOrServices || [];
  const rows = products.length ? products : [];

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setValueDataRow(ws, row, COL_START, COL_END, item, [
      { col: COL_START, value: String(idx + 1), align: "center", fill: undefined, font: BODY_FONT },
      { col: 5, value: item?.productOrService ?? "", align: "left" },
      { col: 6, value: item?.nicCode ?? "", align: "left" },
      { col: COL_END, value: formatTurnoverPct(item?.turnoverPercentage), align: "center" },
    ]);
    ws.getRow(row).height = 15.5;
  });

  const nicLinkRow = DATA_START_ROW + rows.length;
  const nicLabel = ws.getCell(nicLinkRow, 5);
  nicLabel.value = "NIC Code list link:";
  nicLabel.font = RED_LABEL_FONT;
  nicLabel.alignment = { horizontal: "left", vertical: "middle" };

  const nicLink = ws.getCell(nicLinkRow, 6);
  nicLink.value = {
    text: NIC_CODE_LIST_URL,
    hyperlink: NIC_CODE_LIST_URL,
  };
  nicLink.font = LINK_FONT;
  nicLink.alignment = { horizontal: "left", vertical: "middle" };

  hideRowsThrough(ws, 5);
  return ws;
}
